import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
//import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  /*{
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home"  '@/views/HomeView.vue')
  },*/
  {
    path: '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "login"*/  '@/views/LoginView.vue')
  },
  {
    path: '/registro',
    name: 'registro',
    component: () => import(/* webpackChunkName: "registro"*/  '@/views/RegistroView.vue')
  },
  {
    path: '/registroExplotacion',
    name: 'registroExplotacion',
    component: () => import(/* webpackChunkName: "registroExplotacion"*/  '@/views/RegistroExplotacionView.vue')
  },
  {
    path: '/reiniciarContrasena',
    name: 'reiniciarContrasena',
    component: ()=> import(/* webpackChunkName: "reiniciarContrasena"*/  '@/views/ReinicarPasswordView.vue')
  },
  {
    path: '/olvidemicontrasena',
    name: 'olvidemicontrasena',
    component: ()=> import(/* webpackChunkName: "olvidemicontrasena"*/  '@/views/OlvidePasswordView.vue')
  },
  {
    path: '/confirmarUsuario',
    name: 'confirmarUsuario',
    component: ()=> import(/* webpackChunkName: "confirmarUsuario"*/  '@/views/ConfirmarUsuarioView.vue')
  },
  {
    path: '/aplicacion',
    name: 'aplicacion',
    component: ()=> import(/* webpackChunkName: "aplicacion"*/  '@/views/Aplicacion/AplicacionView.vue'),
    children: [
      {
        path: '',
        name: 'principal',
        component: ()=> import(/* webpackChunkName: "principal"*/  '@/views/Aplicacion/PrincipalView.vue'),
      },
      {
        path: 'perfil',
        name: 'perfil',
        component: ()=>import(/* webpackChunkName: "perfil"*/  '@/views/Aplicacion/PerfilView.vue'),
      },
      {
        path: 'formEdit',
        name: 'formEdit',
        props: true,
        component: ()=> import(/* webpackChunkName: "formEdit"*/  '@/components/Templates/TemplateFormGenerico.vue'),
      },
      {
        path: 'formEditView',
        name: 'formEditView',
        props: true,
        component: ()=> import(/* webpackChunkName: "formEdit"*/  '@/components/Templates/TemplateFormGenericoView.vue'),
      },
      {
        path: 'explotacion',
        name: 'explotacion',
        component: ()=>import(/* webpackChunkName: "explotacion"*/  '@/views/Aplicacion/ExplotacionView.vue'),
      },
      /**Menú de Ficheros */
      {
        path: 'aplicadores',
        name: 'aplicadores',
        component: ()=>import(/* webpackChunkName: "aplicadores"*/  '@/views/Aplicacion/Ficheros/AplicadoresView.vue'),
      },
      {
        path: 'asesores',
        name: 'asesores',
        component: ()=>import(/* webpackChunkName: "asesores"*/  '@/views/Aplicacion/Ficheros/AsesoresView.vue'),
      },
      {
        path: 'maquinariasEquipos',
        name: 'maquinariasEquipos',
        component: ()=>import(/* webpackChunkName: "maquinariasEquipos"*/  '@/views/Aplicacion/Ficheros/MaquinariasEquiposView.vue'),
      },
      {
        path: 'instalacionesEdificaciones',
        name: 'instalacionesEdificaciones',
        component: ()=>import(/* webpackChunkName: "instalacionesEdificaciones"*/  '@/views/Aplicacion/Ficheros/InstalacionesEdificacionesView.vue'),
      },
      {
        path: 'dgc',
        name: 'dgc',
        component: ()=>import(/* webpackChunkName: "dgc"*/  '@/views/Aplicacion/Ficheros/DGCView.vue'),
      },
      /**Menú Cuaderno Campo */
      {
        path: '/cubiertasvegetales',
        name: 'cubiertasvegetales',
        component: ()=>import(/* webpackChunkName: "cubiertasvegetales"*/  '@/views/Aplicacion/CuadernoCampo/CubiertasVegetalesView.vue'),
      },
      {
        path: '/cubiertasinertes',
        name: 'cubiertasinertes',
        component: ()=>import(/* webpackChunkName: "cubiertasinertes"*/  '@/views/Aplicacion/CuadernoCampo/CubiertasInertesView.vue'),
      },
      {
        path: '/pastoreo',
        name: 'pastoreo',
        component: ()=>import(/* webpackChunkName: "pastoreo"*/  '@/views/Aplicacion/CuadernoCampo/PastoreoView.vue'),
      },
      {
        path: '/siembraPlantacion',
        name: 'siembraPlantacion',
        component: ()=>import(/* webpackChunkName: "siembraPlantacion"*/  '@/views/Aplicacion/CuadernoCampo/SiembraPlantacionView.vue'),
      },
      {
        path: '/cosechas',
        name: 'cosechas',
        component: ()=>import(/* webpackChunkName: "cosechas"*/  '@/views/Aplicacion/CuadernoCampo/CosechasView.vue'),
      },
      {
        path: '/analiticas',
        name: 'analiticas',
        component: ()=>import(/* webpackChunkName: "analiticas"*/  '@/views/Aplicacion/CuadernoCampo/AnaliticasView.vue'),
      },
      {
        path: '/tratamientoEdifInstalacion',
        name: 'tratamientoEdifInstalacion',
        component: ()=>import(/* webpackChunkName: "tratamientoEdifInstalacion"*/  '@/views/Aplicacion/CuadernoCampo/TratamientoEdifInstalacionView.vue'),
      },
      {
        path: '/tratamientoPostCosecha',
        name: 'tratamientoPostCosecha',
        component: ()=>import(/* webpackChunkName: "tratamientoPostCosecha"*/  '@/views/Aplicacion/CuadernoCampo/TratamientoPostCosechaView.vue'),
      },
      {
        path: '/tratamientoFitosanitario',
        name: 'tratamientoFitosanitario',
        component: ()=>import(/* webpackChunkName: "tratamientoFitosanitario"*/  '@/views/Aplicacion/CuadernoCampo/TratamientoFitosanitarioView.vue'),
      },
      {
        path: '/riegos',
        name: 'riegos',
        component: ()=>import(/* webpackChunkName: "riegos"*/  '@/views/Aplicacion/CuadernoCampo/RiegoView.vue'),
      },
      {
        path: '/comercializacion',
        name: 'comercializacion',
        component: ()=>import(/* webpackChunkName: "comercializacion"*/  '@/views/Aplicacion/CuadernoCampo/ComercializacionView.vue'),
      },
      {
        path: '/fertilizaciones',
        name: 'fertilizaciones',
        component: ()=>import(/* webpackChunkName: "fertilizaciones"*/  '@/views/Aplicacion/CuadernoCampo/FertilizacionesView.vue'),
      },
      {
        path: '/actividadesAgrarias',
        name: 'actividadesAgrarias',
        component: ()=>import(/* webpackChunkName: "actividadesAgrarias"*/  '@/views/Aplicacion/CuadernoCampo/ActividadesAgrariasView.vue'),
      },
      /**Menú Auxiliares */
      {
        path: 'aspafitos',
        name: 'aspafitos',
        component: ()=>import(/* webpackChunkName: "aspafitos"*/  '@/views/Aplicacion/Auxiliares/AspafitosView.vue'),
      },
      {
        path: 'provincias',
        name: 'provincias',
        component: ()=>import(/* webpackChunkName: "provincias"*/  '@/views/Aplicacion/Auxiliares/ProvinciasView.vue'),
      },
      {
        path: 'municipios',
        name: 'municipios',
        component: ()=>import(/* webpackChunkName: "municipios"*/  '@/views/Aplicacion/Auxiliares/MunicipiosView.vue'),
      },
      {
        path: 'actividadAgraria',
        name: 'actividadAgraria',
        component: ()=>import(/* webpackChunkName: "municipios"*/  '@/views/Aplicacion/Auxiliares/ActividadAgrariaView.vue'),
      },
      {
        path: 'asociacionRaza',
        name: 'asociacionRaza',
        component: ()=>import(/* webpackChunkName: "municipios"*/  '@/views/Aplicacion/Auxiliares/AsociacionRazasView.vue'),
      },
      {
        path: 'tipoCoberturaSuelo',
        name: 'tipoCoberturaSuelo',
        component: ()=>import(/* webpackChunkName: "municipios"*/  '@/views/Aplicacion/Auxiliares/TipoCoberturaSueloView.vue'),
      },
      /**Menú SuperAdministrador */
      {
        path: 'operaciones',
        name: 'operaciones',
        component: ()=>import(/* webpackChunkName: "operaciones"*/  '@/views/Aplicacion/SuperAdministrador/OperacionesView.vue'),
      },
      {
        path: 'auditoriaAccesos',
        name: 'auditoriaAccesos',
        component: ()=>import(/* webpackChunkName: "operaciones"*/  '@/views/Aplicacion/SuperAdministrador/AuditoriaAccesosView.vue')
      },
      {
        path: 'auditoriaRegistros',
        name: 'auditoriaRegistros',
        component: ()=>import(/* webpackChunkName: "operaciones"*/  '@/views/Aplicacion/SuperAdministrador/AuditoriaRegistrosView.vue')
      },
      {
        path: 'empresasSA',
        name: 'empresasSA',
        component: ()=>import(/* webpackChunkName: "operaciones"*/  '@/views/Aplicacion/SuperAdministrador/EmpresasSAView.vue')
      },
      {
        path: 'usuariosSA',
        name: 'usuariosSA',
        component: ()=>import(/* webpackChunkName: "operaciones"*/  '@/views/Aplicacion/SuperAdministrador/UsuariosSAView.vue')
      },
      {
        path: 'versiones',
        name: 'versiones',
        component: ()=>import(/* webpackChunkName: "versiones"*/  '@/views/Aplicacion/SuperAdministrador/VersionesView.vue')
      },
      {
        path: 'extensiones',
        name: 'extensiones',
        component: ()=>import(/* webpackChunkName: "extensiones"*/  '@/views/Aplicacion/SuperAdministrador/ExtensionesView.vue')
      },
      {
        path: 'enlacesComunidades',
        name: 'enlacesComunidades',
        component: ()=>import(/* webpackChunkName: "enlacesComunidades"*/  '@/views/Aplicacion/SuperAdministrador/EnlacesComunidadesView.vue')
      },
      /** Menú Gestor del sitio */
      {
        path: 'empresasGS',
        name: 'empresasGS',
        component: ()=>import(/* webpackChunkName: "operaciones"*/  '@/views/Aplicacion/GestorDelSitio/EmpresasGSView.vue')
      }
    ]
  }
  /*{
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about"  '../views/AboutView.vue')
  }*/
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
